export type LogicalExp = 'OR' | 'AND' | 'SINGLE';
export type FacetType = 'filter/string/exact' | 'filter/string/group' | 'filter/string/any' | 'filter/date/range'| 'filter/date/range/start' | 'filter/date/range/end';
export enum FacetTypeEnum { //eslint-disable-line @stencil-community/ban-exported-const-enums
    Exact = 'filter/string/exact',
    Group = 'filter/string/group',
    Any = 'filter/string/any',
    Date = 'filter/date/range',
    DateStart = 'filter/date/range/start',
    DateEnd = 'filter/date/range/end',
    RangePrice = 'filter/range/price',
    RangeStart = 'filter/number/range/start',
    RangeEnd = 'filter/number/range/end',
    RangeStartMargin = 'filter/number/range/start/margin',
    RangeEndMargin = 'filter/number/range/end/margin'
}
export interface Facet {
    fieldName: string
    displayName?: string;
    fieldValues: Array<FacetValue>
    fieldTranslation?: string,
    id?: string
}
export interface FacetValue {
    displayName?: string
    selected?: boolean
    fieldValue: string
    fieldTranslation?: string
    count: number
    children?: Array<FacetValue>
    query?: string
    uniqueId?:string;
    chipDisabled?:boolean;
}
export interface FacetCose {
    fieldName: string
    fieldTranslation?: string
    count: 9239
    expression: LogicalExp
    fieldValues: Array<FacetValueCose>
    children: Array<FacetValueCose>
    id: string
    selected: false
    type: FacetType;
    uniqueId?:string;
    //DRUTY
    displayName?: string;
    rangeType?: string;
}

export interface FacetValueCose {
    displayName?: string
    selected?: boolean
    fieldValue: string
    fieldTranslation?: string
    count: number
    children?: Array<FacetValue>
    query?: string
    expression?: 'OR' | 'AND'
    value?: string;
    type?: FacetType;
    uniqueId?:string;
}

export interface I3Facet {
    displayName: string
    filters: []
    id: string
    multipleLevels: boolean
    selectionType: 'SINGLE' | 'MULTI'
}

export interface DateFacet {
    type: string
    id: string
    children: Array<DateFacetChild>
  }

export interface DateFacetChild {
    type: string
    value: string
  }

export interface NestedFacet {
    fieldName: string;
    displayName?: string;
    fieldValues: Array<FacetValue>;
    fieldTranslation?: string;
    id?: string;
    children?: Array<NestedFacetValue>;
  }

export interface NestedFacetValue extends FacetValue {
    fieldValues: Array<FacetValue>
  }

export interface NestedFilter {
    id: string;
    value: string;
  }
